import React, { forwardRef } from 'react';

import MUISkeleton, {
  SkeletonProps as MUISkeletonProps,
} from '@material-ui/lab/Skeleton';

interface SkeletonProps extends Omit<MUISkeletonProps, 'variant'> {
  variant?: 'text' | 'rectangular' | 'circular' | undefined;
}

function getVariant(
  legacyName: 'text' | 'rectangular' | 'circular' | undefined
) {
  switch (legacyName) {
    case 'rectangular':
      return 'rect';
    case 'circular':
      return 'circle';
    default:
      return 'text';
  }
}

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>((props, ref) => {
  const { variant: legacyName, ...rest } = props;

  const variant = getVariant(legacyName);

  return <MUISkeleton {...rest} ref={ref} variant={variant} />;
});

Skeleton.displayName = 'Skeleton';

export default Skeleton;
